import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders } from '@angular/common/http';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class QualificationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllQualification(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.qualificationUrl}/all`,
			'getAllQualification'
		);
	}

	getQualificationByService(serviceId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.qualificationUrl}/getByService/${serviceId}`,
			'getByService'
		);
	}

	getQualificationByIntervenant(intervenantId: number): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.qualificationUrl}/getByIntervenant/${intervenantId}`,
			'getByIntervenant'
		);
	}

	getQualificationById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.qualificationUrl}/get/${id}`,
			'getQualificationById'
		);
	}

	updateQualification(qualification: Prestation): Observable<Prestation> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.qualificationUrl}/update/${qualification.id}`,
			'updateQualification',
			qualification
		);
	}

	addQualification(qualification: Prestation): Observable<Prestation> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.qualificationUrl}/add`,
			'addQualification',
			qualification
		);
	}

	deleteQualification(qualificationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.qualificationUrl}/delete/${qualificationId}`,
			`deleteQualification`
		);
	}

}
